module.exports = __webpack_public_path__ + "static/img/IMG_20160101_163205.22814573.jpg";